export const getFeedbackEmailTemplate = (toName, fromName, fromEmail, message) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background-color: #1c293a; color: white; padding: 20px; text-align: center; }
        .content { background-color: #f9f9f9; padding: 20px; border: 1px solid #ddd; }
        .message-box { 
          padding: 12px; 
          border-left: 4px solid #d0d0d0; 
          font-style: italic; 
          background-color: white; 
          margin: 15px 0; 
        }
        .footer { text-align: center; margin-top: 20px; color: #666; font-size: 14px; }
        .from-info { color: #1c293a; font-weight: bold; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h2>📝 New Feedback Received</h2>
        </div>
        <div class="content">
          <p>Hello <strong>${toName}</strong>,</p>
          
          <p>We wanted to inform you that <span class="from-info">${fromName} (${fromEmail})</span> has recently provided feedback regarding our services. Here's a summary of their message:</p>
          
          <div class="message-box">
            ${message.replace(/\n/g, '<br>')}
          </div>
        </div>
        
        <div class="footer">
          <p>Best wishes,<br><strong>Walkspan</strong></p>
        </div>
      </div>
    </body>
    </html>
  `;
};